import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  ellipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

export default styles;
